var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 397,
    viewBox: "0 0 400 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.676 24.8H118.134C113.75 24.8 109.546 26.5415 106.446 29.6413C103.346 32.7411 101.605 36.9454 101.605 41.3292V111.6L250.405 155L399.205 111.6V41.3292C399.205 36.9454 397.463 32.7411 394.363 29.6413C391.264 26.5415 387.059 24.8 382.676 24.8V24.8Z",
    fill: "#41A5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.205 111.6H101.605V198.4L250.405 241.8L399.205 198.4V111.6Z",
    fill: "#2B7CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.205 198.4H101.605V285.2L250.405 328.6L399.205 285.2V198.4Z",
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.205 285.2H101.605V355.471C101.605 359.855 103.346 364.059 106.446 367.159C109.546 370.259 113.75 372 118.134 372H382.676C387.059 372 391.264 370.259 394.363 367.159C397.463 364.059 399.205 359.855 399.205 355.471V285.2Z",
    fill: "#103F91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M209.076 86.8H101.605V322.4H209.076C213.455 322.387 217.652 320.641 220.749 317.544C223.846 314.447 225.592 310.251 225.605 305.871V103.329C225.592 98.9494 223.846 94.7527 220.749 91.6557C217.652 88.5587 213.455 86.8131 209.076 86.8V86.8Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.676 99.2H101.605V334.8H196.676C201.055 334.787 205.252 333.041 208.349 329.944C211.446 326.847 213.192 322.651 213.205 318.271V115.729C213.192 111.349 211.446 107.153 208.349 104.056C205.252 100.959 201.055 99.2131 196.676 99.2V99.2Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.676 99.2H101.605V310H196.676C201.055 309.987 205.252 308.241 208.349 305.144C211.446 302.047 213.192 297.851 213.205 293.471V115.729C213.192 111.349 211.446 107.153 208.349 104.056C205.252 100.959 201.055 99.2131 196.676 99.2V99.2Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.276 99.2H101.605V310H184.276C188.655 309.987 192.852 308.241 195.949 305.144C199.046 302.047 200.792 297.851 200.805 293.471V115.729C200.792 111.349 199.046 107.153 195.949 104.056C192.852 100.959 188.655 99.2131 184.276 99.2V99.2Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9339 99.2H184.276C188.659 99.2 192.864 100.941 195.964 104.041C199.063 107.141 200.805 111.345 200.805 115.729V281.071C200.805 285.455 199.063 289.659 195.964 292.759C192.864 295.859 188.659 297.6 184.276 297.6H18.9339C14.5501 297.6 10.3458 295.859 7.24602 292.759C4.14619 289.659 2.40472 285.455 2.40472 281.071L2.40472 115.729C2.40472 111.345 4.14619 107.141 7.24602 104.041C10.3458 100.941 14.5501 99.2 18.9339 99.2V99.2Z",
    fill: "#185ABD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.585 260.4H128.265L102.225 174.84L74.9447 260.4H52.6247L27.8247 136.4H50.1447L67.5047 223.2L93.5447 138.88H112.145L136.945 223.2L154.305 136.4H175.385L150.585 260.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word-icon.eb7864ec04ad749aa0dd7ddd196df9bb.svg";
export { ForwardRef as ReactComponent };